import React from 'react'
import { Grid, Typography, Box } from '@material-ui/core'
import { Image } from 'react-bootstrap'
import { CONFIG } from '../../../../Config/config'
import { isClientRole } from 'Utils/Validators/roles'
import { get } from 'lodash'
import injectStyles from 'react-jss'
import styles from './styles'
import { getReadableRoleByUser } from '../utils'
const UserInfo = ({ data, classes }) => {
  const {
    firstName,
    lastName,
    mobilePhone,
    email,
    client,
    city,
    status,
    profilePicture,
  } = data

  const clientId = get(client, 'id')

  const role = getReadableRoleByUser(data)

  const roleLabel = {
    [CONFIG.USER_ROLE.ADMIN]: 'Administrator',
    [CONFIG.USER_ROLE.CITY_MANAGER]: 'City Manager',
    [CONFIG.USER_SUBROLE.CITY_MANAGER_ASSISTANT]: 'City Manager Assistant',
    [CONFIG.USER_ROLE.CLIENT_ADMIN]: 'Client Admin',
    [CONFIG.USER_ROLE.CLIENT]: 'Client',
    [CONFIG.USER_ROLE.RECRUITER]: 'Recruiter',
    [CONFIG.USER_ROLE.SPY]: 'Spy',
  }
  const characters = 34
  const adjustmentSize = field => String(field).length > characters

  return (
    <Grid container justifyContent="space-between">
      <Grid item lg={10}>
        <Grid container direction="row" spacing={4}>
          <Grid item xs={adjustmentSize(firstName) ? 'auto' : 3}>
            <Box className={classes.box}>
              <Typography
                className={classes.label}
                cypress_id={'firstNameLabel'}
              >
                First Name
              </Typography>
              <Typography
                className={classes.description}
                cypress_id={'firstNameDescription'}
              >
                {firstName}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={adjustmentSize(lastName) ? 'auto' : 3}>
            <Box className={classes.box}>
              <Typography
                className={classes.label}
                cypress_id={'lastNameLabel'}
              >
                Last Name
              </Typography>
              <Typography
                className={classes.description}
                cypress_id={'lastNameDescription'}
              >
                {lastName}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box className={classes.box}>
              <Typography
                className={classes.label}
                cypress_id={'mobilePhoneLabel'}
              >
                Mobile Phone
              </Typography>
              <Typography
                className={classes.description}
                cypress_id={'mobilePhoneDescription'}
              >
                {mobilePhone}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={4}>
          <Grid item>
            <Box className={classes.box}>
              <Typography
                className={classes.label}
                cypress_id={'emailAddressLabel'}
              >
                Email Address
              </Typography>
              <Typography
                className={classes.description}
                cypress_id={'emailAddressDescription'}
              >
                {email}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={4}>
          <Grid item xs={3}>
            <Box className={classes.box}>
              <Typography className={classes.label} cypress_id={'roleLabel'}>
                Role
              </Typography>
              <Typography
                className={classes.description}
                cypress_id={'roleDescription'}
              >
                {roleLabel[role] || role}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={3}>
            {isClientRole(role) ? (
              <Box className={classes.box}>
                <Typography
                  className={classes.label}
                  cypress_id={'clientLabel'}
                >
                  Client
                </Typography>
                <a
                  href={`/dashboard/clients/${clientId}`}
                  target="_blank"
                  cypress_id={'clientDescription'}
                >
                  {get(client, 'name')}
                </a>
              </Box>
            ) : (
              <Box className={classes.box}>
                <Typography className={classes.label} cypress_id={'cityLabel'}>
                  City
                </Typography>
                <Typography
                  className={classes.description}
                  cypress_id={'cityDescription'}
                >
                  {get(city, 'name')}
                </Typography>
              </Box>
            )}
          </Grid>
          <Grid item xs={3}>
            <Box className={classes.box}>
              <Typography className={classes.label} cypress_id={'statusLabel'}>
                Status
              </Typography>
              <Typography
                className={classes.description}
                cypress_id={'statusDescription'}
              >
                {status}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid item lg={2}>
        <Image src={profilePicture} className={classes.profilePicture} />
      </Grid>
    </Grid>
  )
}

export default injectStyles(styles)(UserInfo)
